(function(){
  if(window.__rebGiftPdp)return;window.__rebGiftPdp=1;

  function syncCheckout(on){
    document.querySelectorAll('.accelerated-checkout-button').forEach(function(b){
      b.style.display=on?'none':'';
    });
  }

  document.addEventListener('DOMContentLoaded',function(){
    var card=document.querySelector('.reb-gift-pdp');
    if(card)syncCheckout(card.classList.contains('is-on'));
  });

  document.addEventListener('click',function(e){
    var btn=e.target.closest('.reb-gift-pdp__toggle');
    if(!btn)return;
    e.preventDefault();
    var card=btn.closest('.reb-gift-pdp');
    if(card.classList.contains('is-busy'))return;
    card.classList.add('is-busy');
    var on=btn.getAttribute('aria-checked')==='true';
    var vid=btn.getAttribute('data-vid');
    var url=(on?window.routes.cart_change_url:window.routes.cart_add_url)+'.js';
    var body=on?{id:vid,quantity:0}:{items:[{id:vid,quantity:1}]};
    fetch(url,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(body)})
      .then(function(r){return r.json();})
      .then(function(){
        var nowOn=!on;
        btn.setAttribute('aria-checked',nowOn?'true':'false');
        card.classList.toggle('is-on',nowOn);
        card.classList.remove('is-busy');
        syncCheckout(nowOn);
      })
      .catch(function(){card.classList.remove('is-busy');});
  });
})();